import { z } from "zod";

export const TokensResponseSchema = z.object({
  access_token: z.string().nullish(),
  refresh_token: z.string().nullish(),
});

export type TokensResponse = z.infer<typeof TokensResponseSchema>;
